import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/_services/user/user.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ExitProcessService } from 'src/app/_services/exit-process/exit-prosess.service';


@Component({
  selector: 'app-exit-hrit',
  templateUrl: './exit-hrit.component.html',
  styleUrls: ['./exit-hrit.component.scss']
})
export class ExitHritComponent implements OnInit {
  @Output() clearanceEvent = new EventEmitter<any>();
  tenantId: string;
  userDropdownList = [];
  resignationId: any;
  isHRAdmin: boolean;
  isFinanceAdmin: boolean;
  isITAdmin: boolean;
  currentUser: any;
  userITClearanceForm;
  form: FormGroup;
  clearanceUserId: any;
  editUserClearanceId: any;
  userClearanceData: any[] = [];
  isITAdminCleared: boolean = false;
  clearanceFromITAdminItem: any;
  userClearance= [];
  isClearanceForm: boolean = false;
  modeAction: number = 1; //1 - create // 2 - update
  formMode: number = 0; // 0 - none // 1 - new form // 2 - edit form
  defaultColDef:any;
  rowSelection:any
  dataSource: any;
  public columnDefs: ColDef[];
  sampleGridFrameworkComponents: any;
  private api: GridApi;
  private columnApi: ColumnApi;
  selectedRow: any;
  rowData: any;
  isAckVisible: boolean;

  constructor(
    private storageService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private exitProcessService: ExitProcessService,
  ) {
    this.route.queryParams.subscribe(params => {
      this.resignationId = params['resignationId'];
    });

    this.userITClearanceForm = this.formBuilder.group({
      itemName: new FormControl(''),
      status: new FormControl(''),
      clearanceType: new FormControl(''),
      extraColumn1: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isITAdmin = this.currentUser.roles.includes('RoleITAdministrator');
    this.isHRAdmin = this.currentUser.roles.includes('RoleHrmAdministrator');
    this.getUserSeparation(this.resignationId);
  }

  getUserSeparation(resignationId){
    this.exitProcessService.getUserSeparationsById(resignationId).subscribe({
      next : (value) => {
        this.clearanceUserId = value['userId'];
        this.getUserITClearance();

        const clearanceData1 = this.userClearanceData.find(data => data.itemName === 'Clearance from Reporting Manager');
        const isDeptCleared = clearanceData1 ? clearanceData1.status === "Done" : null;

        const clearanceData2 = this.userClearanceData.find(data => data.itemName === 'Clearance From IT');
        const isITCleared = clearanceData2 ? clearanceData2.status === "Yes" : null;

        const clearanceData3 = this.userClearanceData.find(data => data.itemName === 'Clearance From Finance');
        const isFinanceCleared = clearanceData3 ? clearanceData3.status === "Yes" : null;

        const clearanceData4 = this.userClearanceData.find(data => data.itemName === 'Clearance From HR & Admin');
        const isHRCleared = clearanceData4 ? clearanceData4.status === "Yes" : null;
        
        if(isDeptCleared && isITCleared && isFinanceCleared && isHRCleared){
          this.isAckVisible === true
        }
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Resignation Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  getUserITClearance(){
    this.exitProcessService.getUserClearanceForm('IT', this.resignationId).subscribe({
      next : (value: any) => {
        this.userClearanceData = [];
        // this.userClearanceData = value;

        this.userClearanceData = value.filter(
          item => item.clearanceType === 'IT' &&
          item.itemName !== 'Clearance From IT' // exclude this from table
        );

        this.clearanceFromITAdminItem = value.find(
          item => item.clearanceType === 'IT' &&
                  item.itemName === 'Clearance From IT'
        );

        this.isITAdminCleared = value.find(
          item =>
            item.clearanceType === 'IT' &&
            item.itemName === 'Clearance From IT'
        )?.status;

        this.clearanceEvent.emit(value);
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Clearance Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  onITAdminClearanceChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    const newStatus = checked ? 'Yes' : 'No';
  
    let updatePayload = {
      userId: this.clearanceUserId,
      itemName: this.clearanceFromITAdminItem.itemName,
      status: newStatus,
      clearanceType: 'IT',
    }

    this.exitProcessService.editClearanceInterviewForm(updatePayload, this.clearanceFromITAdminItem.id).subscribe({
      next: () => {
        this.clearanceFromITAdminItem.status = newStatus;
        this.openSnackBar('Clearance status updated!!!');
      },
      error: (err) => {
        this.openSnackBar('Error updating clearance: ' + err);
      }
    });
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  cancelSave(){
    this.formMode = 0;
    this.isClearanceForm = false;
  }

  requiredSaveUserClearance() {
    if (this.userITClearanceForm.status === 'INVALID') return true;
    else return false;
  }

  updateUserITClearance(){
    let data = {
      userId: this.clearanceUserId,
      itemName: this.userITClearanceForm.get('itemName').value,
      status: this.userITClearanceForm.get('status').value,
      extraColumn1: this.userITClearanceForm.get('extraColumn1').value,
      clearanceType: 'IT',
    }
    if (!this.requiredSaveUserClearance()) {
      this.exitProcessService.editClearanceInterviewForm(data, this.editUserClearanceId).subscribe({
        next: (value) =>{
          this.getUserITClearance();
        },
        error(error){
          this.openSnackBar('ERROR: ' + error);
        },
        complete(){
          this.openSnackBar('Update Successfull!!!');
        }
      });
    }
  }

  editUserITClearanceById(id) {
    this.formMode = 2;
    this.isClearanceForm = true;
    const idx = this.userClearanceData.findIndex(i => i.id === id);
    this.editUserClearanceId = id;
    this.userITClearanceForm.patchValue({
      itemName: this.userClearanceData[idx].itemName,
      status: this.userClearanceData[idx].status,
      extraColumn1: this.userClearanceData[idx].extraColumn1
    });
  }

  visibleUserClearanceForm() {
    if (this.formMode === 0) {
      this.isClearanceForm = true;
      this.formMode = 1;
      this.userITClearanceForm.patchValue({
          itemName: '',
          status: '',
          clearanceType: '',
          extraColumn1: '',
      })
    } else if (this.formMode === 1) {
      this.userITClearanceForm = false;
      this.formMode = 0;
    }
  }

  saveUserITClearance(){
    let data = {
      userId: this.clearanceUserId,
      itemName: this.userITClearanceForm.get('itemName').value,
      status: this.userITClearanceForm.get('status').value,
      extraColumn1: this.userITClearanceForm.get('extraColumn1').value,
      clearanceType: 'IT',
    }
    console.log('data', data);
    if (!this.requiredSaveUserClearance()) {
      this.exitProcessService.createClearanceInterviewForm(data).subscribe({
        next: (value) =>{
          this.getUserITClearance();
          this.cancelSave();
          // this.formMode = 0;
          // this.userClearanceForm = false;
        },
        error(error){
          this.openSnackBar('ERROR: ' + error);
        },
        complete(){
          this.openSnackBar('Create Successfull!!!');
        }
      });
    }
  }

  backToExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-process']);
  }

  openExitForm(){
    this.router.navigate([this.tenantId + '/dashboard/hr/exit-formalities/exit-form'], { queryParams: { resignationId: this.resignationId } });
  }

  openFinanceExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-finance' ], { queryParams: { resignationId: this.resignationId } });
  }

  openDepartmentExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-department'], {queryParams: {resignationId: this.resignationId }});
  }

  openHrExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-hr-admin'], {queryParams: {resignationId: this.resignationId}});
  }
  
  employeeAnknow(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/emply-anknowledge'], {queryParams: {resignationId: this.resignationId}});
  }
}
